// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1nh9f","vLegacy":"SelectSecondary_vLegacy__2Pfzf","error":"SelectSecondary_error__28pTq","disabled":"SelectSecondary_disabled__3gf_c"};